import { resetData } from '../State/data'

export default () => async (dispatch) => {

  dispatch(resetData())

}
